<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      class="text-center mt-5"
      header="Saját fiók szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-card-body class="text-left">
        <div class="col-sm-12">
          <div class="row-fluid">
            <!-- // FORM -->
            <b-form @submit="addElement">

              <div class="form-group">
                <label for="first_name">Vezetéknév</label>
                <b-form-input
                  type="text"
                  v-model="list.last_name"
                  class="form-control"
                  id="first_name"
                  required
                />
              </div>

              <div class="form-group">
                <label for="last_name">Keresztnév</label>
                <b-form-input
                  type="text"
                  v-model="list.first_name"
                  class="form-control"
                  id="last_name"
                  required
                />
              </div>

              <div class="form-group">
                <label for="email">Email</label>
                <b-form-input
                  type="text"
                  v-model="list.email"
                  class="form-control"
                  id="email"
                  required
                />
              </div>

              <div class="form-group">
                <label for="monogram">Monogram</label>
                <b-form-input
                  type="text"
                  v-model="list.monogram"
                  class="form-control"
                  id="monogram"
                  required
                />
              </div>

              <div class="form-group">
                <label for="usertype">Felhasználó típus</label>
                <b-form-select
                v-model="list.usertype"
                :options="userTypeList"
                  class="form-control"
                  id="usertype"
                  required
                ></b-form-select>
              </div>

              <!-- // SAVE -->
              <b-button variant="primary" type="submit">
                <b-icon-cloud-upload></b-icon-cloud-upload>
                Mentés
              </b-button>

              <!-- // CANCEL -->
              <b-button
                variant="outline-danger"
                class="float-right"
                @click="cancelElement()"
                ><b-icon-pencil></b-icon-pencil>
                Mégsem
              </b-button>

            </b-form>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      list: {},
      userTypeList: [
        'user',
        'admin'
      ]      
    }
  },
  methods: {
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.list.usertype
        payload.first_name = this.list.first_name
        payload.last_name = this.list.last_name
        payload.email = this.list.email
        payload.monogram = this.list.monogram
        payload.id = this.list.id
        axios
          .post(process.env.ROOT_API+'/users/save', { payload })
          .then(res => {
            if(this.userType == "admin") {
              this.$router.push({ name: 'Register' })
            } else {
              this.$router.push({ name: 'Profile' })
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    cancelElement () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if(this.userType == "admin") {
          this.$router.push({ name: 'Register' })
        } else {
          this.$router.push({ name: 'Profile' })
        }
      }
    }
  },
  mounted: function () {
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.token = this.token
      payload.userType = this.userType
      payload.email = this.$route.params.email
      if (email) {
        axios
          .post(process.env.ROOT_API+'/users/edit', { payload })
          .then(res => {
            this.list = res.data
            this.list.id = res.data.id
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserNew.vue